import { useRpQuery } from '~/composables/graphql'
import { useMutation } from '@tanstack/vue-query'
import type { SignDocumentInput } from '~/resources/graphql/graphql'
import { graphql } from '~/resources/graphql'
import { useActiveFacility } from '~/composables/use-active-facility'

export function useGiftCardSignDocumentMutation() {
    const query = useRpQuery()
    const activeFacility = useActiveFacility()

    return useMutation({
        mutationFn: (mutationData: SignDocumentInput) =>
            query(
                graphql(/** @lang GraphQL */ `
                    mutation GiftCardSignDocumentMutation(
                        $input: SignDocumentInput!
                        $facilityId: ID!
                    ) {
                        signDocument(input: $input) {
                            __typename
                            ... on SignDocumentResult {
                                recordId
                                record {
                                    __typename
                                    ... on PlanContract {
                                        ...PurchaseGiftCardContractFragment
                                    }
                                }
                                query {
                                    viewer {
                                        cart(facilityId: $facilityId) {
                                            ...ViewerCartFragment
                                        }
                                    }
                                }
                            }
                            ... on ValidationError {
                                fieldErrors {
                                    path
                                    message
                                }
                            }
                        }
                    }
                `),
                {
                    input: mutationData,
                    facilityId: activeFacility.value.id
                }
            )
    })
}
